import { getBleed, Stack } from '@cheqroom/ui';
import tw, { styled } from 'twin.macro';

export const StyledWorkspacesList = styled(Stack)`
	${tw`max-h-[222px] overflow-auto`}
	${getBleed(4)}
`;
